import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { IconAddress, IconCalendar, IconRequirementsList, NamedLink } from '../../components';

import css from './Tender.module.css';

const addSpace = value => value?.replace(/\n/g, '<br>');

const STATUS_OPEN = 'open';
const STATUS_FULFILLED = 'fulfilled';
const STATUS_EXPIRED = 'expired';

export const Tender = ({
  history,
  listing,
  onChangeRestrictModalState,
  showNoSubscriptionButton,
  showPartialSubscriptionButton,
  onGetTransactionsByListingId,
}) => {
  const {
    tenderDatesStart,
    tenderDatesEnd,
    submissionDeadlineDate,
    requirements,
    location,
    tenderStatus,
  } = listing?.attributes?.publicData ?? {};

  const formattedStart = tenderDatesStart && moment(tenderDatesStart).format('DD MMM');
  const formattedEnd = tenderDatesEnd && moment(tenderDatesEnd).format('DD MMM YYYY');
  const formattedDeadline =
    submissionDeadlineDate && moment(submissionDeadlineDate).format('D MMMM YYYY');

  const status =
    tenderStatus === STATUS_OPEN ? (
      <FormattedMessage id="TendersPage.deadlineBanner" values={{ date: formattedDeadline }} />
    ) : tenderStatus === STATUS_FULFILLED ? (
      <FormattedMessage id="TendersPage.deadlineBannerFulfilled" />
    ) : (
      <FormattedMessage id="TendersPage.deadlineBannerExpired" />
    );

  const buttonClasses = classNames(css.link, {
    [css.viewButton]: tenderStatus === STATUS_OPEN,
    [css.viewButtonDisabled]: tenderStatus !== STATUS_OPEN,
  });

  const selectRedirectPage = async () => {
   const initiatedTenderId = await onGetTransactionsByListingId(listing?.id?.uuid);

    initiatedTenderId
      ? history.push(`/tender/${initiatedTenderId}/order`)
      : history.push(`/tender/${listing?.id?.uuid}`);
  }

  return (
    <div className={css.root}>
      <div
        className={classNames({
          [css.blur]: [STATUS_FULFILLED, STATUS_EXPIRED].includes(tenderStatus),
        })}
      />

      <div
        className={classNames({
          [css.statusLabel]: tenderStatus === STATUS_OPEN,
          [css.statusLabelFulfilled]: tenderStatus === STATUS_FULFILLED,
          [css.statusLabelExpired]: tenderStatus === STATUS_EXPIRED,
        })}
      >
        {status}
      </div>
      <div className={css.county}>{listing?.attributes?.title}</div>
      <div className={css.address}>
        <IconAddress rootClassName={css.icon} />
        <span>{location?.selectedPlace?.secondaryText}</span>
      </div>
      <hr />
      <div className={css.dates}>
        <IconCalendar rootClassName={css.icon} />
        <span>
          {formattedStart} - {formattedEnd}
        </span>
      </div>
      <hr />
      <div className={css.requirements}>
        <IconRequirementsList rootClassName={css.icon} />
        <FormattedMessage id="TendersPage.equipmentRequirementsTitle" />
      </div>
      <div
        className={css.requirementsList}
        dangerouslySetInnerHTML={{ __html: addSpace(requirements) }}
      />
      {showNoSubscriptionButton ? (
        <div className={buttonClasses} onClick={() => onChangeRestrictModalState(true)}>
          <FormattedMessage id="TendersPage.viewButtonMessage" />
        </div>
      ) : showPartialSubscriptionButton ? (
        <div className={buttonClasses} onClick={() => onChangeRestrictModalState(true)}>
          <FormattedMessage id="TendersPage.viewButtonMessage" />
        </div>
      ) : (
        <div className={css.link} onClick={selectRedirectPage}>
          <div className={buttonClasses}>
            <FormattedMessage id="TendersPage.viewButtonMessage" />
          </div>
        </div>
      )}
    </div>
  );
};
